import axios from "axios";

const InitialState = {
  counterOrganizations: null,
  counterRequests: null,
};

const MANAGE_OOP_RESOURCES_ORGANIZATIONS_INDEX_TYPE = "MANAGE_OOP_RESOURCES_ORGANIZATIONS_INDEX_TYPE";

function counterOrganizationsGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-organizations-organizations", {
    headers: {'Accept': 'application/json'},
  });
}

function counterRequestsGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-organizations-requests", {
    headers: {'Accept': 'application/json'},
  });
}

function counterOrganizationsReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_ORGANIZATIONS_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterOrganizations: item
      }
    }
  }
}

function counterRequestsReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_ORGANIZATIONS_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterRequests: item
      }
    }
  }
}

export function counterOrganizationsQuery() {
  return (dispatch) => {
    return counterOrganizationsGetRequest()
      .then(response => {
        dispatch(counterOrganizationsReceive(response.data))
      }, err => {
        dispatch(counterOrganizationsReceive(null))
      })
  }
}

export function counterRequestsQuery() {
  return (dispatch) => {
    return counterRequestsGetRequest()
      .then(response => {
        dispatch(counterRequestsReceive(response.data))
      }, err => {
        dispatch(counterRequestsReceive(null))
      })
  }
}

export function reducer(state = InitialState, action) {
  if (action.type === MANAGE_OOP_RESOURCES_ORGANIZATIONS_INDEX_TYPE) {
    return action.reduce(state)
  }
  return state;
}
